/* FAQs (sections/main-faq-lenora.liquid)
   - Search: hides questions that don't mention the words typed, opens the
     ones that do, hides empty categories, and says how many matched.
   - Topics list: highlights the category currently in view. A passive
     scroll check rather than an IntersectionObserver, which behaves the
     same everywhere. */
(() => {
  const init = (root) => {
    const groups = Array.from(root.querySelectorAll("[data-faq-group]"));
    const items = groups.flatMap((group) =>
      Array.from(group.querySelectorAll("details")).map((details) => ({
        group,
        details,
        text: details.textContent.toLowerCase().replace(/\s+/g, " "),
      }))
    );
    const input = root.querySelector("[data-faq-search]");
    const status = root.querySelector("[data-faq-status]");
    const empty = root.querySelector("[data-faq-empty]");
    const links = Array.from(root.querySelectorAll("[data-faq-link]"));

    // Remember which questions the shopper opened themselves, so clearing
    // the search puts them back the way they were.
    const openedByHand = new WeakSet();
    items.forEach(({ details }) => {
      if (details.open) openedByHand.add(details);
      details.addEventListener("toggle", () => {
        // toggle fires asynchronously, after runSearch has finished, so check
        // the class (which stays on while there's a query) rather than a flag.
        if (root.classList.contains("is-searching")) return;
        details.open ? openedByHand.add(details) : openedByHand.delete(details);
      });
    });

    const runSearch = () => {
      const words = input.value.toLowerCase().trim().split(/\s+/).filter(Boolean);
      const searching = words.length > 0;
      root.classList.toggle("is-searching", searching);

      let matches = 0;
      items.forEach(({ details, text }) => {
        const hit = !searching || words.every((word) => text.includes(word));
        details.hidden = !hit;
        if (hit) matches += 1;
        details.open = searching ? hit && words.join("").length >= 3 : openedByHand.has(details);
      });
      groups.forEach((group) => {
        group.hidden = !Array.from(group.querySelectorAll("details")).some((d) => !d.hidden);
      });
      links.forEach((link) => {
        const group = root.querySelector(`#${link.dataset.faqLink}`);
        link.parentElement.hidden = !!group && group.hidden;
      });

      if (empty) empty.hidden = !searching || matches > 0;
      if (status) {
        status.textContent = !searching
          ? ""
          : matches === 0
            ? "No answers match"
            : `${matches} ${matches === 1 ? "answer" : "answers"} found`;
      }
    };

    if (input) {
      input.addEventListener("input", runSearch);
      input.addEventListener("search", runSearch);
    }

    // Topic highlight: the last category whose top has passed the upper
    // third of the screen.
    if (links.length) {
      let current = null;
      const check = () => {
        const line = window.innerHeight * 0.33;
        let active = null;
        groups.forEach((group) => {
          if (!group.hidden && group.getBoundingClientRect().top <= line) active = group.id;
        });
        if (!active && groups.length) active = groups.find((g) => !g.hidden)?.id || null;
        if (active === current) return;
        current = active;
        links.forEach((link) => {
          const on = link.dataset.faqLink === active;
          link.classList.toggle("is-active", on);
          if (on) link.setAttribute("aria-current", "true");
          else link.removeAttribute("aria-current");
        });
        // On narrow screens the topics are a sideways-scrolling row of chips;
        // keep the active one in view. (Scrolls only the row, never the page.)
        const list = links[0].closest("ul");
        const activeLink = links.find((link) => link.dataset.faqLink === active);
        if (list && activeLink && list.scrollWidth > list.clientWidth) {
          list.scrollTo({
            left: activeLink.parentElement.offsetLeft - list.offsetLeft - 16,
            behavior: "smooth",
          });
        }
      };
      window.addEventListener("scroll", check, { passive: true });
      window.addEventListener("resize", check, { passive: true });
      check();
    }
  };

  const start = () => document.querySelectorAll("[data-faq]").forEach(init);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
